import "@/App.css";
import "@fontsource/fredoka/400.css";
import "@fontsource/fredoka/500.css";
import "@fontsource/fredoka/600.css";
import "@fontsource/fredoka/700.css";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";
import "@fontsource/literata/400.css";
import "@fontsource/literata/500.css";
import "@fontsource/literata/400-italic.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import NavBar from "@/components/NavBar";
import ProtectedRoute, { Loader } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Library from "@/pages/Library";
import Reader from "@/pages/Reader";
import Generator from "@/pages/Generator";
import Atelier from "@/pages/Atelier";
import Profile from "@/pages/Profile";
import Premium from "@/pages/Premium";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import Confidentialite from "@/pages/legal/Confidentialite";
import CguCgv from "@/pages/legal/CguCgv";

const P = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function Home() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  return user ? <Navigate to="/bibliotheque" replace /> : <Landing />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/connexion" element={<AuthPage />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reinitialiser" element={<ResetPassword />} />
            <Route path="/bibliotheque" element={P(<Library />)} />
            <Route path="/histoire/:id" element={P(<Reader />)} />
            <Route path="/creer" element={P(<Generator />)} />
            <Route path="/atelier" element={P(<Atelier />)} />
            <Route path="/atelier/:id" element={P(<Atelier />)} />
            <Route path="/profil" element={P(<Profile />)} />
            <Route path="/premium" element={P(<Premium />)} />
            <Route path="/payment/success" element={P(<PaymentSuccess />)} />
            <Route path="/payment/cancel" element={P(<PaymentCancel />)} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/cgu-cgv" element={<CguCgv />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
